import { render } from "./check_company.vue?vue&type=template&id=d1a4a1fe&scoped=true"
import script from "./check_company.vue?vue&type=script&lang=js"
export * from "./check_company.vue?vue&type=script&lang=js"

import "./check_company.vue?vue&type=style&index=0&id=d1a4a1fe&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a4a1fe"]])

export default __exports__